/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_LabelInputs */

const vi_invoice_misa_template_label = /** @type {(inputs: Invoice_Misa_Template_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu hóa đơn MISA`)
};

/**

* @param {Invoice_Misa_Template_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_label = /** @type {((inputs?: Invoice_Misa_Template_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_label(inputs)
});